<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        Upload document
      </h3>

      <validation-observer ref="document-download-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <label for="name">Name:</label>
              <d-input
                v-model="data.name"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="files"
              v-slot="{ errors }">
              <file-input
                :onChange="setDocumentFile"
                id="inputFileDocumentFile" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'DocumentPopup',
  data () {
    return {
      isVisible: false,
      loading: false,
      data: {
        name: '',
        country_id: null,
        files: []
      }
    };
  },
  mounted () {
    this.$bus.$on('show-document-download-popup', this.show);
  },
  methods: {
    show (mode, referenceId) {
      this.loading = false;
      this.data = {
        name: '',
        country_id: parseInt(referenceId, 10),
        files: null
      };

      setTimeout(() => {
        this.$refs['document-download-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    validateForm () {
      FormUtils.validate(this.$refs['document-download-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let endpointUrl = '/countries/documents/store';
      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.mode === 'add' ? 'Document added' : 'Document saved',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the document. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('document-downloads-list-reload');
        }
      }, ['files']);
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    setDocumentFile (event) {
      this.data.files = [event.target.files[0]];
    },
    prepareFormData () {
      let dataToSend = {
        name: this.data.name,
        country_id: this.data.country_id,
        files: this.data.files
      };

      return dataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-document-download-popup', this.show);
  }
}
</script>
